export default "__VITE_ASSET__d01ac98a__"